import { DesignComponent } from '@design/models/design-component.model';
import { createAction, props } from '@ngrx/store';

export namespace fromDesignComponentActions {
  export const AddDesignComponent = createAction(
    '[Draw Area] add one design component',
    props<{ designComponent: DesignComponent }>()
  );

  export const AddManyDesignComponents = createAction(
    '[Draw Area] add many design components',
    props<{ designComponents: DesignComponent[] }>()
  );

  export const SelectDesignComponent = createAction(
    '[Draw Area] select design component',
    props<{ designComponent: DesignComponent | undefined }>()
  );

  /** Called when the mesh is moved/rotated on the scene. */
  export const UpdateDesignComponent = createAction(
    '[Draw Area] update one design component',
    props<{ designComponent: DesignComponent; triggerURSnapshot?: boolean }>()
  );

  /** Called when the RHS panel edits name/dimensions/mounting/type. */
  export const DesignComponentConfigurationChange = createAction(
    '[Design Component Configuration] Change design component configuration',
    props<{ designComponent: DesignComponent }>()
  );

  export const CopyDesignComponent = createAction(
    '[Design Component Configuration] Copy a design component',
    props<{ designComponent: DesignComponent }>()
  );

  export const DeleteDesignComponent = createAction(
    '[Design Component Configuration] Delete a design component',
    props<{ designComponent: DesignComponent }>()
  );

  export const DeleteDesignComponentFromStore = createAction(
    '[Design Component Configuration] Delete a design component from store',
    props<{ designComponent: DesignComponent }>()
  );

  export const DeleteDesignComponentSuccess = createAction(
    '[Design Component Configuration] Delete a design component success',
    props<{ designComponent: DesignComponent }>()
  );

  export const SaveDesignComponents = createAction(
    '[Save design component] Save design component data to quote api'
  );

  export const ClearDesignComponents = createAction(
    '[meta data] clear design component data'
  );
}
